import { useEffect } from 'react';
import { getDelayOfPopupSignUp } from 'helpers/getDelayOfPopupSignUp';
import { setSearchParam } from 'helpers/setSearchParam';

import { SessionStorageManager, SiteConfigManager, useApplicationState } from '@atlas/core';
import { staticRoutes } from '@atlas/routing';

import { POPUP_SIGN_UP_DELAY_STORAGE_KEYS } from 'common/constants';
import history from 'components/Layout/history';

const { signup } = staticRoutes;
const { NEXT_SHOW, TIMEOUT_ID } = POPUP_SIGN_UP_DELAY_STORAGE_KEYS;

export const useShowPopupSignUpDelay = () => {
  const { authenticated, loading } = useApplicationState();

  useEffect(() => {
    const enableSignUpDelay = SiteConfigManager.getConfig(
      'config.config.registration.desktop_popup',
    );
    let timeoutId;

    if (enableSignUpDelay) {
      const { pathname, search } = history.location;
      const isSignIn = search.includes('cmd=signin');
      const isSignUpDelay = search.includes('cmd=signup-delay');
      const isSignUpPopup = search.includes('cmd=signup');
      const isForgotPassword = search.includes('cmd=forgotPassword');
      const isResetPassword = search.includes('cmd=resetPassword');
      const isResetPasswordPhone = search.includes('cmd=resetPasswordPhone');
      const isEmailVerification = search.includes('cmd=emailVerification');
      const isSignUp = pathname === signup;
      const showPopup =
        !isSignIn &&
        !isSignUp &&
        !isSignUpDelay &&
        !isSignUpPopup &&
        !isForgotPassword &&
        !isResetPassword &&
        !isResetPasswordPhone &&
        !isEmailVerification;

      if (showPopup) {
        const delay = getDelayOfPopupSignUp();

        timeoutId = setTimeout(() => {
          SessionStorageManager.removeItem(TIMEOUT_ID);

          const newUrl = setSearchParam(search, 'cmd', 'signup-delay');
          history.replace({ search: newUrl });
        }, delay);

        SessionStorageManager.setItem(TIMEOUT_ID, timeoutId);
      }
    } else {
      const sessionTimeoutId = SessionStorageManager.getItem(TIMEOUT_ID);
      if (sessionTimeoutId) {
        clearTimeout(sessionTimeoutId);
        SessionStorageManager.removeItem(TIMEOUT_ID);
      }
      SessionStorageManager.removeItem(NEXT_SHOW);
    }

    if (authenticated) {
      clearTimeout(timeoutId);
      SessionStorageManager.removeItem(TIMEOUT_ID);
      SessionStorageManager.removeItem(NEXT_SHOW);
    }

    return () => {
      clearTimeout(timeoutId);
      SessionStorageManager.removeItem(TIMEOUT_ID);
    };
  }, [authenticated, loading]);
};
